<template>
    <div>Resultados da Secretaria-Geral do Ministério da Administração Interna - Administração Eleitoral</div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
div {
    color: var(--base-medium-color);
    font-size: .7rem;
    margin-top: 1rem;
    display: block;
    clear: both;
	text-align: center;
	margin-bottom: 2rem;
}
</style>